import React from 'react';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import useUser from 'src/hooks/use-user';

import { TopSellersCarousel } from 'src/components/carousels/generic-carousels/top-sellers-carousel';
import { LoggedIn } from './logged-in';
import { LoggedOut } from './logged-out';

export const Empty = observer(
  (): JSX.Element => {
    const { isLoggedIn } = useUser();

    return (
      <>
        <Wrapper>
          <div>
            <Heading>Your Cart Is Empty</Heading>
            <Description>
              {isLoggedIn ? 'Check out what we’re featuring today!' : 'Log in to view your past orders.'}
            </Description>

            {isLoggedIn ? <LoggedIn /> : <LoggedOut />}
          </div>
        </Wrapper>

        <CarouselContainer>
          <TopSellersCarousel isSmallTitle alwaysUseSmallCards />
        </CarouselContainer>
      </>
    );
  }
);

const Wrapper = styled.div`
  background: #fff;
  border-top: 4px solid #f0f0f0;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 300px;
  padding: 32px;
  text-align: center;
  width: 100%;
`;

const Heading = styled.h2`
  font-size: 20px;
  font-weight: 700;
  line-height: ${24 / 20};
`;

const Description = styled.p`
  color: #485055;
  margin-top: 8px;
`;

const CarouselContainer = styled.div`
  background: #fff;
  border-top: 16px solid #f0f0f0;
  padding: 0 20px;
`;
